// constants
import { CHART_ERROR_MESSAGES, CHART_FAILED_MESSAGE, ChartErrorCode } from 'constants/chartErrors'
// utils
import { castArray } from 'lodash'
import { parseGraphQLErrorCodes } from 'utils/errors/parsers'

// What a chart's tile says about its error: by the first chart code the error carries, or the fallback
export const getChartErrorMessage = (error: unknown, fallback = CHART_FAILED_MESSAGE) => {
  const codes: string[] = castArray(parseGraphQLErrorCodes(error) || [])
  const code = codes.find((item) => CHART_ERROR_MESSAGES[item as ChartErrorCode])

  return code ? CHART_ERROR_MESSAGES[code as ChartErrorCode] : fallback
}
